export const secondaryTheme = {
  animate: true,
  transition: '0.4s ease background',
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1920
    }
  },
  components: {
    LayoutHeader: {
      styleOverrides: {
        borderColor: '#202020'
      }
    },
    BreadCrumb: {
      styleOverrides: {
        background: '#202020',
        color: '#fff'
      }
    },
    AccordionWithArrow: {
      styleOverrides: {
        titleBackground1: '#000',
        titleBackground2: '#000',
        background1: '#000',
        background2: 'transparent',
        borderColor1: '#222',
        borderColor2: '#222',
        buttonColor: '#fff',
        buttonBackground: '#222',
        overlay: 'rgba(0, 0, 0, 0.4)'
      }
    },
    MuiIconButton: {
      styleOverrides: {
        color: '#fff',
        tickColor: '#fff',
        crossColor: '#fff'
      }
    },
    MuiTextField: {
      styleOverrides: {
        background1: '#333',
        borderColor: '#545454',
        color: '#fff',
        disabledColor: '#b8b8b8',
        placeholderColor: '#b8b8b8',
        fontSize: '14px'
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        borderColor: '#949494',
        backgroundColor: '#949494',
        color: '#fff',
        disabledColor: '#b8b8b8',
        fontSize: '14px'
      }
    },
    GridList: {
      styleOverrides: {
        color: '#fff',
        disabledColor: '#b8b8b8',
        borderColor: '#222',
        iconBorderColor: '#fff',
        tabColor: '#fff',
        tabBackground: '#000',
        tabIndicatorBackground: '#727272',
        tdOddBackground: '#222222',
        tdEvenBackground: '#ffffff',
        tdHoverBackground: '#727272',
        tdSelectedBackground: '#727272',
        tdItemClickedBackground: '#727272',
        paginationBg: '#000',
        paginationColor: '#fff',
        paginationBorderBg: '#222',
        paginationSelectedBg: '#fff',
        paginationSelectedColor: '#000'
      }
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          background: '#545454',
          borderRadius: 10
        }
      }
    },
    MuiSelect: {
      defaultProps: {
        // disableElevation: true
      },
      styleOverrides: {
        borderColor: '#545454',
        color: '#fff',
        disabledColor: '#b8b8b8',
        placeholderColor: '#b8b8b8',
        fontSize: '14px'
      }
      // styleOverrides: {
      //   root: {
      //     borderRadius: 4
      //   },
      //   sizeXSmall: {
      //     padding: '4px 20px',
      //     border: '1px red solid'
      //   }
      // }
    },
    MuiTooltip: {
      defaultProps: {
        zIndex: 1000
      },
      styleOverrides: {
        root: {
          zIndex: 1000
        }
      }
    },
    MuiButton: {
      defaultProps: {
        // disableElevation: true
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 0 // button border radius
        },
        sizeChip: {
          padding: '0 8px',
          lineHeight: 1.5,
          fontSize: 11,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        },
        sizeXSmall: {
          padding: '4px 20px'
        },
        sizeSmall: {
          padding: '6px 12px',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.5
        },
        sizeMedium: {
          padding: '8px 20px'
        },
        sizeLarge: {
          padding: '11px 24px'
        },
        textSizeSmall: {
          padding: '7px 12px'
        },
        textSizeMedium: {
          padding: '9px 16px'
        },
        textSizeLarge: {
          padding: '12px 16px'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4 // button border radius
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        // disableRipple: true
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '32px 24px',
          '&:last-child': {
            paddingBottom: '32px'
          }
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          variant: 'h6'
        },
        subheaderTypographyProps: {
          variant: 'body2'
        }
      },
      styleOverrides: {
        root: {
          padding: '32px 24px'
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
          margin: 0,
          padding: 0
        },
        html: {
          MozOsxFontSmoothing: 'grayscale',
          WebkitFontSmoothing: 'antialiased',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%',
          width: '100%'
        },
        body: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          minHeight: '100%',
          transition: '0.2s ease background',
          width: '100%'
        }
      }
    },
    MuiParagraph: {
      styleOverrides: {
        color: '#fff',
        lightColor: '#939393'
      }
    },
    LoaderDots: {
      styleOverrides: {
        dotColor: '#fff',
        overlayBackground: 'rgba(0, 0, 0, 0.4)'
      }
    },
    Modal: {
      styleOverrides: {
        background: '#333',
        color: '#fff',
        overlay: 'rgba(0,0,0,0.5)'
      }
    }
  },
  palette: {
    neutral: {
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937',
      // 900: '#111827',
      // 900: '#f7f7f7'
      900: '#EA5F2E',
      950: '#fff'
    },
    action: {
      active: '#6B7280',
      focus: 'rgba(55, 65, 81, 0.12)',
      hover: 'rgba(55, 65, 81, 0.04)',
      selected: 'rgba(55, 65, 81, 0.08)',
      disabledBackground: 'rgba(55, 65, 81, 0.12)',
      disabled: 'rgba(55, 65, 81, 0.26)'
    },
    background: {
      default: '#000',
      paper: '#FFFFFF',
      index: '#000',
      main: '#39374e' // new background
    },
    divider: '#E6E8F0',
    primary: {
      main: '#fff',
      light: '#f1f1f1',
      dark: '#f1f1f1', // hover
      contrastText: '#000'
    },
    secondary: {
      main: '#666a6d',
      light: '#3FC79A',
      dark: '#0B815A',
      contrastText: '#FFFFFF'
    },
    success: {
      main: '#14B8A6',
      light: '#43C6B7',
      dark: '#0E8074',
      contrastText: '#FFFFFF'
    },
    info: {
      main: '#2196F3',
      light: '#64B6F7',
      dark: '#0B79D0',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#FFB020',
      light: '#FFBF4C',
      dark: '#B27B16',
      contrastText: '#FFFFFF'
    },
    error: {
      main: '#D14343',
      light: '#DA6868',
      dark: '#922E2E',
      contrastText: '#FFFFFF'
    },
    text: {
      primary: '#fff',
      // primary: 'rgba(255,0,0,0)',
      secondary: '#65748B',
      disabled: 'rgba(55, 65, 81, 0.48)'
    }
  },
  shape: {
    borderRadius: 8, // works on mui card
    round: {
      borderRadius: '10px'
    }
  },
  shadows: [
    'none',
    '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
    '0px 1px 2px rgba(100, 116, 139, 0.12)',
    '0px 1px 4px rgba(100, 116, 139, 0.12)',
    '0px 1px 5px rgba(100, 116, 139, 0.12)',
    '0px 1px 6px rgba(100, 116, 139, 0.12)',
    '0px 2px 6px rgba(100, 116, 139, 0.12)',
    '0px 3px 6px rgba(100, 116, 139, 0.12)',
    '0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)',
    '0px 5px 12px rgba(100, 116, 139, 0.12)',
    '0px 5px 14px rgba(100, 116, 139, 0.12)',
    '0px 5px 15px rgba(100, 116, 139, 0.12)',
    '0px 6px 15px rgba(100, 116, 139, 0.12)',
    '0px 7px 15px rgba(100, 116, 139, 0.12)',
    '0px 8px 15px rgba(100, 116, 139, 0.12)',
    '0px 9px 15px rgba(100, 116, 139, 0.12)',
    '0px 10px 15px rgba(100, 116, 139, 0.12)',
    '0px 12px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 13px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 14px 24px -8px rgba(100, 116, 139, 0.25)',
    '0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)'
  ],
  typography: {
    button: {
      fontWeight: 400
    },
    fontFamily: "'Poppins', 'Montserrat',sans-serif",
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.57
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.75
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.57
    },
    overline: {
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '0.5px',
      lineHeight: 2.5,
      textTransform: 'uppercase'
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.66
    },
    h1: {
      fontWeight: 700,
      fontSize: '3.5rem',
      lineHeight: 1.375
    },
    h2: {
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.375
    },
    h3: {
      fontWeight: 700,
      fontSize: '2.25rem',
      lineHeight: 1.375
    },
    h4: {
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.375
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.375
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.125rem',
      lineHeight: 1.375
    }
  },

  overrides: {
    MuiButton: {
      sizeLarge: {
        margin: '11px 0'
      },
      sizeSmall: {
        padding: '4px 0'
      },
      palette: {
        neutral: '#6B7280'
      }
    }
  }
}
